import React from 'react';
import './Contact.css';
import {
  RiPhoneLine,
  RiMailLine,
  RiMapPinLine,
  RiTimeLine
} from 'react-icons/ri';

const Contact = () => {
  return (
    <section className="contact-page">
      <div className="contact-container">
        <div className="contact-info">
          <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <RiMapPinLine color="#38bdf8" /> Get in Touch
          </h2>
          <p>We’d love to hear from you. Whether you have a question about features, pricing, need a demo, or anything else — our team is ready to answer all your questions.</p>

          <ul className="info-list">
            <li><strong><RiPhoneLine style={{ marginRight: '8px' }} /> Phone:</strong> +1 (800) 123-4567</li>
            <li><strong><RiMailLine style={{ marginRight: '8px' }} /> Email:</strong> support@yourcompany.com</li>
            <li><strong><RiMapPinLine style={{ marginRight: '8px' }} /> Address:</strong> 123 Tech Street, Innovation City, NY</li>
            <li><strong><RiTimeLine style={{ marginRight: '8px' }} /> Working Hours:</strong> Mon - Fri: 9am - 6pm</li>
          </ul>
        </div>

        <form className="contact-form">
          <h3>Send Us a Message</h3>
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <input type="text" placeholder="Subject" />
          <textarea placeholder="Your Message" required></textarea>
          <button type="submit">Send Message</button>
        </form>
      </div>

      <div className="map-section">
        <h3><RiMapPinLine style={{ marginRight: '10px' }} /> Our Office Location</h3>
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.993503925003!2d-74.00594168459345!3d40.71277577933156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDQyJzQ2LjAiTiA3NMKwMDAnMjMuMCJX!5e0!3m2!1sen!2sus!4v1619192323655!5m2!1sen!2sus"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </section>
  );
};

export default Contact;
